import { notification } from 'antd'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'

import { AssignmentZonesApi } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los datos',
  })
}

const useGetAssignmentZones = () => {
  const {
    data: zones,
    isLoading: assignmentZoneIsLoading,
    refetch: assigmentZoneRefetch,
  } = useQuery(QUERY_KEYS.ASSIGNMENT_ZONES, AssignmentZonesApi.getAssignmentZones, {
    onError,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  })

  return { zones, assignmentZoneIsLoading, assigmentZoneRefetch }
}

export default useGetAssignmentZones
